// Dependencies: hls.js, plyr.js
// Verwendung: Füge das data-bg-hls-video Attribut zu einem Container hinzu,
// um ein Hintergrundvideo mit HLS-Unterstützung zu erstellen.
jQuery(window).ready(function () {
    // Überprüfe, ob wir uns im Brizy Editor befinden
    if (
        window.location.href.indexOf('is-editor-iframe') !== -1 ||
        window.location.href.indexOf('action=architect') !== -1 ||
        window.location.href.indexOf('tve=true') !== -1
    ) {
        return;
    }

    $dependencyManager.addDependenciesCallback(['hls', 'plyr'], () => {
        // Find all containers with a data-bg-hls-video attribute
        jQuery('[data-bg-hls-video]').each(function () {
            const container = jQuery(this);
            const videoSrc = container.attr('data-bg-hls-video');
            if (!videoSrc) return;

            let bgContainer = container.find('.brz-bg').first();
            if (bgContainer.length === 0) {
                bgContainer = container;
            }


            // Create a wrapper for video and overlay
            const wrapper = jQuery('<div>', {
                class: 'mad-hero-video-wrapper',
                css: {
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    marginLeft: 'auto',
                    marginRight: '0',
                    width: '100%',
                }
            });

            const videoEl = jQuery('<video>', {
                class: 'mad-hero-video',
                playsinline: '',
                muted: '',
                autoplay: '',
                loop: '',
                controls: false,
                css: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    opacity: '0',
                    display: 'block',
                    position: 'relative',
                    zIndex: 0
                }
            });

            // Overlay div
            const overlay = jQuery('<div>', {
                class: 'mad-hero-video-overlay',
                css: {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1,
                    pointerEvents: 'none',
                    background: 'linear-gradient(to right, rgba(0,0,0,1.0), rgba(0,0,0,0.1))'
                }
            });

            wrapper.append(videoEl).append(overlay);

            const bgColor = bgContainer.find('.brz-bg-color').first();

            if (bgColor.length) {
                wrapper.insertBefore(bgColor);
            } else {
                bgContainer.append(wrapper);
            }

            // Sobald das Video spielt, animiere die Opazität zu 1 (fade in)
            videoEl.on('playing', function() {
                jQuery(this).animate({ opacity: 1 }, 1500);
            });

            // Initialisiere die Video-Wiedergabe via hls.js falls unterstützt
            if (Hls.isSupported()) {
                const hls = new Hls({ startLevel: 3,
                    maxBufferLength: 20,
                    maxMaxBufferLength: 60,
                    maxBufferSize: 60 * 1000 * 1000,
                    maxBufferHole: 0.5,
                  }); // Start Quality 3 = 720p (abhänging von den verfügbaren Qualitäten auf BunnyCDN)
                hls.loadSource(videoSrc);
                hls.attachMedia(videoEl[0]);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    videoEl[0].play().catch(err => console.error('Error trying to play:', err));
                });
            } else if (videoEl[0].canPlayType('application/vnd.apple.mpegurl')) {
                videoEl.attr('src', videoSrc);
                videoEl.on('loadedmetadata', function () {
                    videoEl[0].play().catch(err => console.error('Error trying to play:', err));
                });
            }

            // Initialisiere Plyr ohne Steuerungselemente
            const player = new Plyr(videoEl[0], {
                controls: [],
                autoplay: true,
                muted: true,
                loop: { active: true },
                playsinline: true,
                settings: [],
                storage: { enabled: false },
                clickToPlay: false
            });

            // Setze den Plyr-Container so, dass er den gesamten Hintergrund abdeckt
            const plyrContainer = jQuery(player.elements.container);
            if (plyrContainer.length) {
                // Function to adjust plyr container and overlay styles based on window width
                function adjustPlyrContainerAndOverlay() {
                    if (window.innerWidth > 1500) {
                        plyrContainer.css({
                            position: 'absolute',
                            top: '0',
                            right: 0,
                            left: 'auto',
                            width: '80vw',
                            height: '100%',
                            objectFit: 'cover',
                        });
                        overlay.css({
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            left: 'auto',
                            width: '80vw',
                            height: '100%',
                        });
                    } else {
                        plyrContainer.css({
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            right: 'auto',
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        });
                        overlay.css({
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 'auto',
                            width: '100%',
                            height: '100%',
                        });
                    }
                }
                // Initial adjustment
                adjustPlyrContainerAndOverlay();
                // Listen for window resize
                window.addEventListener('resize', adjustPlyrContainerAndOverlay);
            }
        });
    });
});